export default {
  common: {
    nav: {
      home: "Главная",
      find_offer_help: "Найти / Предложить помощь",
      celebrate: "Отметить жизнь",
      family_tree: "Семейное древо",
      events: "События",
      civic_reports: "Гражданские отчёты",
      neighborhood_pulse: "Пульс района",
      weather: "Погода",
      nature: "Природа",
      marketplace: "Маркет",
      news: "Новости",
      causes: "Инициативы",
      more: "Ещё",
    },
    header: { sign_in: "Войти", join: "Присоединиться к Social Pulse", language: "Язык", search: "Поиск" },
    tagline: "Соединяем сообщества · Расширяем возможности · Создаём социальный капитал",
    locality: { viewing_from: "Вы просматриваете из", change: "Изменить", set_your_location: "Укажите местоположение" },
    news: { title: "Ваш ежедневный обзор.", play_briefing: "Слушать ежедневный обзор", listen: "Слушать", translate: "Перевести" },
  },
};
